import { createContext, useContext } from 'react';

export const EditRoleContext = createContext();

export const useEditRoleContext = () => useContext(EditRoleContext);
